import React, { lazy, Suspense } from "react";

const RemoteToast = lazy(() =>
  import("../../../../shared/components/Toast/Toast").then((module) => ({ default: module.ToastContainer }))
);

const Toast = () => {
  return (
    <Suspense>
      <RemoteToast />
    </Suspense>
  );
};

export { Toast };
